var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E4E7DD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23319_42728",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23319_42728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3751 20.0209L16.0001 18.4376L18.6251 20.0417L17.9376 17.0417L20.2501 15.0417L17.2084 14.7709L16.0001 11.9376L14.7918 14.7501L11.7501 15.0209L14.0626 17.0417L13.3751 20.0209ZM16.0001 20.3959L12.5418 22.4792C12.389 22.5765 12.2293 22.6181 12.0626 22.6042C11.8959 22.5904 11.7501 22.5348 11.6251 22.4376C11.5001 22.3404 11.4029 22.2188 11.3334 22.073C11.264 21.9272 11.2501 21.764 11.2918 21.5834L12.2084 17.6459L9.14593 15.0001C9.00704 14.8751 8.92023 14.7327 8.88551 14.573C8.85079 14.4133 8.86121 14.257 8.91676 14.1042C8.97232 13.9515 9.05565 13.8265 9.16676 13.7292C9.27787 13.632 9.43065 13.5695 9.62509 13.5417L13.6668 13.1876L15.2293 9.47925C15.2987 9.31258 15.4063 9.18758 15.5522 9.10425C15.698 9.02091 15.8473 8.97925 16.0001 8.97925C16.1529 8.97925 16.3022 9.02091 16.448 9.10425C16.5938 9.18758 16.7015 9.31258 16.7709 9.47925L18.3334 13.1876L22.3751 13.5417C22.5695 13.5695 22.7223 13.632 22.8334 13.7292C22.9445 13.8265 23.0279 13.9515 23.0834 14.1042C23.139 14.257 23.1494 14.4133 23.1147 14.573C23.08 14.7327 22.9931 14.8751 22.8543 15.0001L19.7918 17.6459L20.7084 21.5834C20.7501 21.764 20.7362 21.9272 20.6668 22.073C20.5973 22.2188 20.5001 22.3404 20.3751 22.4376C20.2501 22.5348 20.1043 22.5904 19.9376 22.6042C19.7709 22.6181 19.6112 22.5765 19.4584 22.4792L16.0001 20.3959Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarOutline);
export default __webpack_public_path__ + "static/media/rating-star-outline.b16ed5906335015a08e10f0f38befd06.svg";
export { ForwardRef as ReactComponent };